export default "__VITE_ASSET__BfP58F8P__"